import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { BModal, BFormRow, BCol, BButton, BFormGroup } from 'bootstrap-vue'
import { TranslateResult } from 'vue-i18n'
import { DateMixin, NumberMixin, Spinner } from '@kwixeo/interface-vue'
import { fetchLot, needFetchLot } from '../../fetchDatas/lot'
import ManualMovementItem from '../ManualMovementItem/ManualMovementItem.vue'
import { mapGetters } from 'vuex'

@Component({
  components: {
    ManualMovementItem,
    BModal, BFormRow, BCol, BButton, BFormGroup,
    Spinner
  },
  computed: {
    ...mapGetters('subscriptions', ['hasModule'])
  }
})
export default class LotItem extends Mixins(DateMixin, NumberMixin) {
  hasModule!: (key: string) => boolean

  @Prop({ required: true }) value!: KwixeoCatalog.ProductLot
  @Prop({ required: true }) modalState!: boolean

  private lot: KwixeoCatalog.ProductLot|null = null
  private manualMovementItem: KwixeoCatalog.StockManualMovement|null = null

  get originLabel (): TranslateResult|string|null {
    if (!this.lot) {
      return null
    }

    let content
    switch (this.lot.origin_type) {
      case 'stockManualContent':
        content = this.lot.origin as KwixeoCatalog.StockManualMovement
        return 'Mouvement de stock manuel n°' + content.reference
      case 'providerCommandContent':
        content = this.lot.origin as KwixeoCatalog.Command
        return 'Commande fournisseur n°' + content.reference
      default:
        return null
    }
  }

  get useLabel (): (use: KwixeoCatalog.ProductLotUse) => TranslateResult|string|null {
    return (use: KwixeoCatalog.ProductLotUse|null) => {
      if (!use) {
        return null
      }

      switch (use.element_type) {
        case 'stockManualContent':
          return 'Mouvement de stock manuel n°' + use.element.reference
        case 'providerCommandContent':
          return 'Commande fournisseur n°' + use.element.reference
        default:
          return null
      }
    }
  }

  get withDate (): boolean {
    return (this.lot?.uses?.filter(use => use.element_type !== 'affairContent').length ?? 0) > 0
  }

  @Watch('value', { immediate: true })
  private async watchValue (value: KwixeoCatalog.ProductLot|null): Promise<void> {
    if (!value) {
      return
    }
    if (needFetchLot(value)) {
      this.lot = null
      value = await fetchLot(value.id)
    }
    this.lot = JSON.parse(JSON.stringify(value))
  }

  private showManualMovement (movement: KwixeoCatalog.StockManualMovement): void {
    this.manualMovementItem = movement

    const modal = this.$refs.modal as BModal
    modal.hide();
  }
}
